import React from 'react';
import { trackEvent } from 'src/services/analytics';
import { useCurrentRefinements, useClearRefinements } from 'react-instantsearch-hooks-web';
import { InputTagCollapsingList } from '@src/components/InputTagList/InputTagCollapsingList';
import { AlgoliaFacets } from '@src/clients/Algolia/constants';
import { formatMoney } from '@src/utilities/numberFormattingUtility';

export const checkLabelText = (item, refinement): string => {
	switch (item.attribute) {
		case 'fundingLevel':
			return refinement.value === '\\-1'
				? '100% tuition paid'
				: `Up to ${formatMoney(refinement.value)} tuition paid per year`;
		case 'completionTimeRange':
			return `Time to complete: ${refinement.value}`;
		case 'weeklyEffortRange':
			return `Effort: ${refinement.value}`;
		case AlgoliaFacets['High school GPA']:
			return `Min HS GPA ${refinement.label}`;
		case AlgoliaFacets['College GPA']:
			return `Min College GPA ${refinement.label}`;
		case AlgoliaFacets['College credits']:
			return `Min College Credits ${refinement.label}`;
		default:
			return handleDefault(refinement);
	}
};

const handleDefault = refinement => {
	if (refinement.label.includes('>')) {
		if (refinement.value.includes('Certificates & bootcamps >')) {
			return `${refinement.label.split('>')[1]} Certificate`;
		} else {
			return refinement.label.split('>')[1];
		}
	} else {
		return refinement.label;
	}
};

export const FacetsInputTagList: React.FC = () => {
	const { items, refine } = useCurrentRefinements();
	const { refine: clearRefinements } = useClearRefinements();

	const refinements = items.reduce((acc, item) => {
		item.refinements.forEach(refinement => {
			if (
				refinement.value !== 'Any time to complete' &&
				refinement.value !== 'Any hours per week'
			) {
				refinement.label = checkLabelText(item, refinement);
				acc.push(refinement);
			}
		});
		return acc;
	}, []);

	const removeAllInputTags = () => {
		clearRefinements();
		trackEvent('FiltersCleared', {});
	};

	const removeInputTag = item => {
		trackEvent('FilterRemoved', {
			filterCategory: item.attribute,
			filterValue: [item.label],
		});
		refine(item);
	};

	return (
		<InputTagCollapsingList
			items={refinements}
			removeAll={removeAllInputTags}
			removeFunction={removeInputTag}
		/>
	);
};
